import { createFileRoute } from '@tanstack/react-router';
import { CreateArticlePage } from '../components/community/CreateArticlePage';

export const Route = createFileRoute('/community/articles/new')({
  component: CreateArticlePage,
});
